/**
 * <PoweredBy /> (r7.6) — the fixed "Powered by ShowzNTicketz" line every tenant screen carries.
 * Product rule 3: not tenant-configurable, not removable from the tenant's branding page. Renders nothing on
 * the platform tenant (the marketplace is ShowzNTicketz). Also used inside the tenant Footer and on the
 * standalone error shells so a 404 on bhajamana.showznticketz.com still says who runs the rails.
 */
import { useTranslation } from 'react-i18next';
import { useTenantOptional } from '@/context/TenantContext';

export default function PoweredBy({ className = '', style = {}, force = false }) {
  const { t } = useTranslation();
  const tenant = useTenantOptional();
  if (!force && (!tenant || tenant.isPlatform)) return null;
  return (
    <div
      className={`text-[11px] tracking-wide ${className}`}
      style={{ color: 'var(--snt-text-3, #8a8378)', ...style }}
      data-testid="powered-by"
    >
      {t('tenant.powered_by', 'Powered by')}{' '}
      <a href="https://showznticketz.com" target="_blank" rel="noopener noreferrer" className="no-underline" style={{ color: 'var(--snt-text-2)' }}>
        ShowzNTicketz
      </a>
    </div>
  );
}
